import apiClient from "../config/axiosConfig";

export default class ORBApi {

  static _doGet(url, responseType, abortSource) {
    let requestOptions = {};
    if (responseType) requestOptions.responseType = responseType;
    if (abortSource) requestOptions.cancelToken = abortSource.token;
    return apiClient.get(url, requestOptions).then((response) => response.data);
  }

  static _doPost(url, data, contentType) {
    const config = {};
    if (contentType) {
      config.headers = { 'content-type': contentType };
    }
    return apiClient.post(url, data, config).then((response) => response.data);
  }

  static _doPatch(url, data, contentType) {
    const config = {};
    if (contentType) {
      config.headers = { 'content-type': contentType };
    }
    return apiClient.patch(url, data, config).then((response) => response.data);
  }

  static getSessionData() {
    return ORBApi._doGet("/admin/sessions/me");
  }
  // Update tracks status
  static updateTrackStatus(tracks) {
    return ORBApi._doPatch("/admin/tracks", tracks);
  }

  // Load single track
  static loadTrack(track_id) {
    return ORBApi._doGet(`/private/tracks/${track_id}`);
  }
  /**
   * Load tracks
   * @param {string} searchFilter Text to search
   * @param {string} status Status to filter by
   * @param {number} page Page number
   * @param {string} sortBy Field to sort by
   * @param {string} sortOrder Sort order ('asc' or 'desc')
   * @returns {Promise}
   */
  static loadTracks(searchFilter, status, page, sortBy, sortOrder) {
    let url = `/admin/tracks?page=${page}`;
    if (searchFilter) url += `&filter=${encodeURIComponent(searchFilter)}`;
    if (status) url += `&status=${status}`;
    if (sortBy && sortBy !== 'undefined') url += `&sort_by=${sortBy}`;
    if (sortOrder && sortOrder !== 'undefined') url += `&sort_order=${sortOrder}`;
    return ORBApi._doGet(url);
  }

  // Download tracks
  static downloadTracks(status) {
    return ORBApi._doGet(`/admin/tracks/export_file?status=${status}`, "blob");
  }

  /**
   * List users 
   * @param {string} status Status to filter by
   * @param {string} search_filter String to be used on filter
   * @param {string} document Document to be used on filter
   * @param {number} page Page of result to show
   * @param {string} sortBy Field name to sort by
   * @param {string} sortOrder Sort order ('asc' or 'desc')
   * @returns {Promise}
   */
  static listUsers(status, search_filter, document, page, sortBy, sortOrder) {
    let url = `/admin/users?page=${page}`;
    if (status) url += `&status=${status}`;
    if (search_filter) url += `&filter=${search_filter}`;
    if (document) url += `&document=${document}`;
    if (sortBy) url += `&sort_by=${sortBy}`;
    if (sortOrder) url += `&sort_order=${sortOrder}`;

    return ORBApi._doGet(url)
  }

  /**
   * Approve the account adding or confirming the ECAD code
   * @param {number} id 
   * @param {string|number} ecad_code 
   * @returns {Promise}
   */
  static approveAccount(id, ecad_code) {
    const payload = {
      ecad_code: ecad_code ? parseInt(ecad_code, 10) : null,
      success: true
    };
    return ORBApi._doPost(`/admin/users/${id}/approvals`, payload);
  }

  /**
   * Get from the API the URL to show the user personal document
   * 
   * @param {number} id User ORB account ID
   * @param {*} show_back True if should get the back of the document
   * @returns {Promise}
   */
  static getUserPersonalDocument(id, show_back = false) {
    let params = show_back ? "?verse=1" : "";
    return ORBApi._doGet(`/admin/users/${id}/personal_document${params}`);
  }

  // Get Company Document URL
  static getUserCompanyDocument(id) {
    return ORBApi._doGet(`/admin/users/${id}/company_document`);
  }

  /**
   * Update the user association 
   * @param {number} user_id ORB Account ID of the user
   * @param {string} association Association name
   */
  static updateUserAssociation(user_id, association) {
    return ORBApi._doPatch(`/admin/users/${user_id}`,{"association": association})
  }
}
